import { Col, Row } from 'antd';
import { t } from 'i18next';
import React from 'react';
import { CustomerFromLogger } from 'src/app/pages/PortalPage/CustomerAndUserPage/CompanyDetailsModal/companyDetails-modal.config';
import styles from 'src/app/pages/PortalPage/CustomerAndUserPage/UserInfoTabModalComponent/UserInfoTabModalContent.module.scss';

interface ContentProps {
  userInfo: CustomerFromLogger;
}
const UserInfoTabModalContent: React.FC<ContentProps> = ({ userInfo }) => {
  const users = userInfo?.data[0];

  const userGeneratedRoles = users?.rolesAndUsersObj;
  const roles = Object.keys(userGeneratedRoles ?? {});

  return (
    <div className={styles.content} id="customerAndUser_modalShowContents">
      <br />

      {roles.map((role, i) => (
        <Row key={i} className={styles.contentRow} id="customerAndUser_showRow">
          <Col span={8} className={styles.contentKeyCol} id="customerAndUser_showCol">
            {t(`Number of ${role}'s`)} {`(${userGeneratedRoles[role].length})`}
          </Col>
          <Col span={16} className={styles.contentValueCol}>
            {/* {users?.adminUser ? users?.adminUser?.map((user) => <div key={user}>{user}</div>) : <div>-</div>} */}
            {userGeneratedRoles[role] ? userGeneratedRoles[role]?.join(', ') : '-'}
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default UserInfoTabModalContent;
